import "./_Video.scss";
import "plyr/src/sass/plyr.scss";
import type Plyr from "plyr";

export interface IVideo
{
	Overlay: HTMLElement;
	Player?: Plyr;
}

export class Video
{
	static Overlay: HTMLElement;
	static Overlays: NodeListOf<HTMLElement>;
	static Videos: IVideo[] = [];
	static Playing = -1;

	constructor()
	{
		this.ConfigureVideo();
	}

	private ConfigureVideo = (): void =>
	{
		const overlays = document.querySelectorAll(".video__overlay");

		if (overlays.length)
		{
			overlays.forEach((overlay: HTMLElement) =>
			{
				if (overlay !== null)
				{
					overlay.addEventListener("click", this.InitializeVideoPlayer);

					Video.Videos.push({
						Overlay: overlay
					});
				}
			});
		}
	};

	private InitializeVideoPlayer = (e: Event): void =>
	{
		e.preventDefault();
		const target = e.currentTarget as HTMLElement;
		const videoContainer = target.closest(".video");

		if (videoContainer !== null)
		{
			const videoEl = videoContainer.querySelector("video");
			const videoIndex = videoContainer.getAttribute("data-video");

			if (videoEl !== null && videoIndex !== null && videoIndex !== "")
			{
				const videoInt = parseInt(videoIndex);

				import("plyr")
					.then((plyr) =>
					{
						const player = new plyr.default(videoEl, {
							controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
						});

						player.on("ready", async (event) =>
						{
							const playPromise = event.detail.plyr.play() as Promise<void>;

							playPromise.catch((error) =>
							{
								console.log("paused before ready");
							});
						});

						player.on("play", async (event) =>
						{
							const target = event.currentTarget as HTMLElement;

							if (target !== null)
							{
								const playerIndex = parseInt(target.closest(".video").getAttribute("data-video"));

								if (!isNaN(playerIndex))
								{
									Video.Playing = playerIndex;
								}
								else
								{
									Video.Playing = -1;
								}
							}
						});

						player.on("ended", async (event) =>
						{
							Video.Playing = -1;
						});

						player.on("pause", async(event) =>
						{
							Video.Playing = -1;
						});

						Video.Videos[videoInt].Player = player;
					});
			}
		}
	};

	static Play = (index: number): void =>
	{
		const toPlay = Video.Videos[index];

		Video.Stop();

		if (typeof toPlay.Player !== "undefined")
		{
			toPlay.Player.play();
		}
		else
		{
			toPlay.Overlay.dispatchEvent(new Event("click"));
		}
	};

	static Stop = (): void =>
	{
		const playing = Video.Playing;

		if (playing > -1)
		{
			Video.Videos[playing].Player.stop();
		}
	};
}